module.exports = __webpack_public_path__ + "static/media/funder-left.5572b78a.jpg";